import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from "react-toastify";

import { fetchDuplicateAsset, invalidateSimiarAsset, replaceSimilarAsset } from 'src/redux/actions/assets';
import Thumbnail from 'src/components/thumbnail';

import _ from 'lodash';
import styles from "./similarContent.module.scss";
import Text from 'src/components/text';

const defaultAsset = "/images/assets/default_asset.jpg";

const SimilarContentView = () => {
  const dispatch = useDispatch();
  const similarity = useSelector((state: any) => state.asset.similarity);
  const previousSimilarityRef = useRef<any>({});

  useEffect(() => {
    if (!similarity) return;

    const updatedPreviousSimilarity = { ...previousSimilarityRef.current };

    Object.keys(similarity).forEach((key) => {
      const currentSimilarity = similarity[key];
      const previousSimilarity = previousSimilarityRef.current[key];

      if (!currentSimilarity || _.isEqual(currentSimilarity, previousSimilarity)) {
        return;
      }

      if (!currentSimilarity.processing && !currentSimilarity.processed && currentSimilarity.initialise) {
        const request = {
          asset: currentSimilarity.item.id,
          threshold: 1,
          page: 0,
          limit: 1,
        };

        dispatch(fetchDuplicateAsset(request));
      }

      if (currentSimilarity.processed && !_.get(previousSimilarity, 'processed')) {
        const toastId = `duplicate-${currentSimilarity.item.id}`;

        toast(
          <ReplaceAssetToast
          asset={currentSimilarity.similarAsset.asset}
          replaceAsset={currentSimilarity.item}
          toastId={toastId}
          />,
          {
            closeOnClick: false,
            autoClose: false,
            toastId: toastId
          }
        )
      }

      updatedPreviousSimilarity[key] = currentSimilarity;
    });

    previousSimilarityRef.current = updatedPreviousSimilarity;
  }, [similarity]);

  return null;
};

export default SimilarContentView;

const ReplaceAssetToast = ({asset, replaceAsset, toastId}) => {
  
  const dispatch = useDispatch();

  const handleContinue = () =>{
    dispatch(replaceSimilarAsset({id: replaceAsset.id, assetId: asset.id}));
    toast.dismiss(toastId);
    dispatch(invalidateSimiarAsset({assetId: replaceAsset.id}));
  }

  const handleClose = () => {
    toast.dismiss(toastId);
    dispatch(invalidateSimiarAsset({assetId: replaceAsset.id}));
  }


  return (
    <div className={styles.toast}>
      <div className={styles.content}>
        <div className={styles.header}>
          <Thumbnail
            className={styles.thumbnail}
            media={asset.icon}
            defaultImage={defaultAsset}
            width={40}
            height={40}
          />
          <div className={styles.overlay}>
            <i className="paperflite-danger"></i>
          </div>
          <div className={styles.name}>
            <Text className={styles.truncate} text={replaceAsset.name} />
          </div>
        </div>

        <div className={styles.body}>
          this asset is exactly similar to &quot; <Text text={asset.name} /> &quot;
        </div>

      </div>

      <div className={styles.actions}>
        <i className="paperflite-danger"></i>
        <span>This asset <Text className={styles.title} text={replaceAsset.name} /> you’re uploading is a duplicate of 
          <Text text={asset.name} className={styles.title} />
        already available in your content. 
        <span className={styles.action} onClick={() => { handleClose() }}> Upload </span>a duplicate copy or <span className={styles.action} onClick={() => handleContinue()}>continue</span> using the existing version?
        </span>
      </div>

      <div className={styles.closeToast}>
        <i className='paperflite-close' onClick={() => { handleClose() }}></i>
      </div>
    </div>
  )
}
